import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { InternalTruckCountryListResponse } from '~/modules/admin/models/admin.model';

@Injectable({
    providedIn: 'root'
})
export class InternalFilterService {
    private apiUrl = `${environment.apiUrl}InternalData/internal-truck-country-list`;

    constructor(private http: HttpClient) { }

    getInternalCountryList(): Observable<InternalTruckCountryListResponse> {
        return this.http.get<InternalTruckCountryListResponse>(this.apiUrl).pipe(
        );
    }

}
